class Publication
  constructor: ($el) ->
    @item = $el || $('.publication-item')
    @_bind()
    @_copyText()
    @item.find('#select-expires-days').trigger('change')


  _bind: ->
    $select = @item.find('#select-expires-days')
    $checkbox = @item.find('.trigger-change-expires')

    $checkbox.change ->
      $select.trigger('change')

    $select.change =>
      value = if $checkbox.is(':checked') then $select.val() else ''
      @item.find('input[name="teams_publication[expires_after_days]"]').val value

    @_generatePin(true)
    # @item.find('.trigger-change-pin').change (e) =>
    #   @_generatePin(e.target.checked)

    @item.find('.pin-item').on 'click', ->
      return false

    @item.find('.link-show-qrcode').on 'click', =>
      @item.toggleClass 'show-qrcode'

  _copyText: ->
    $link = @item.find('.link-copy-text')
    $link.removeClass('hide') if document.queryCommandSupported('copy')

    $link.on 'click', ->
      $('#publication-url').select()
      return unless document.execCommand('copy')
      $link.find('.text').text '成功'
      setTimeout ->
        $link.find('.text').text '复制'
      , 2000

  _generatePin: (checked) ->
    pin = if checked then Math.random().toString(36).substring(2, 10) else ''
    @item.find('.pin-code').text pin
    @item.find('input[name="teams_publication[pin]"]').val pin


tower.publication = ($el) ->
  new Publication($el)
